import { Announcement } from 'type/announcement';
import { BaseService } from './baseService';

class AnnouncementService extends BaseService<Announcement> {
  controllerName = 'announcement';
}
export const announcementService = new AnnouncementService();
